module.exports = __webpack_public_path__ + "static/media/visa-electron.a4ec2cab.svg";